
export const successionPlantingAlgorithm = async (ctx) => {

}